// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebStore_Types_Action = require("../WebStore_Types_Action.bs.js");
var CommonTypes_ResponsiveLayout = require("../../../../shared/src/types/CommonTypes_ResponsiveLayout.bs.js");

var updateLayoutFromDom = {
  TAG: /* SideEffects */1,
  _0: (function (_store, dispatch) {
      return Curry._1(dispatch, WebStore_Types_Action.updateLayout(Relude_Option.fold(/* Desktop */2, CommonTypes_ResponsiveLayout.fromInt, DomUtils.WindowSizing.screenWidth(undefined))));
    })
};

var SideEffects = {
  updateLayoutFromDom: updateLayoutFromDom
};

exports.SideEffects = SideEffects;
/* DomUtils Not a pure module */
